export default __webpack_public_path__ + "static/media/Ahmed.fc7783ae.png";